export default {
  iframe: 'IFrame',
  Open: 'Open',
  OpenIfAgree: 'Open if agree',
  OpenIfTicket: 'Open if have ticket',
  Closed: 'Closed'
}
